import React, { useState } from 'react';
import queryString from 'query-string';
import moment from 'moment';

import { history } from '../../_helpers/history';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../_actions/alert.actions';
import { intakeService } from '../../_services/intake.service';
import { Modal, ListGroup, Row, Col } from 'react-bootstrap';

export default function ExportIntake() {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [exportType, setExportType] = useState("");

  const dispatch = useDispatch();

  const handleExport = (type) => {
    setLoading(true);
    dispatch(alertActions.clear());

    const queryParams = queryString.parse(history.location.search);
    const showDateRange = ("completedOnStart" in queryParams) ? true : false;

    const searchParams = {
      type: type,
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      status: queryParams.status || '',
      completedOn: queryParams.completedOn || '',
      completedOnStart: showDateRange ? queryParams.completedOnStart || '' : '',
      completedOnEnd: showDateRange ? queryParams.completedOnEnd || '' : '',
      questionnaireId: queryParams.questionnaire ? parseInt(queryParams.questionnaire) : '',
    };

    intakeService.exportToken(searchParams)
      .then(data => {
        setLoading(false);
        setShow(false);

        window.open(data.url);
      })
      .catch((error) => {
        setLoading(false);
        setShow(false);

        dispatch(alertActions.error('Something went wrong. Please try again.'));
      });
  }

  const showSelectExportType = () => {
    dispatch(alertActions.clear());

    const queryParams = queryString.parse(history.location.search);
    const showDateRange = ("completedOnStart" in queryParams) ? true : false;

    if (showDateRange && (!queryParams.completedOnStart || !queryParams.completedOnEnd)) {
      dispatch(alertActions.warning('Narrow your results by selecting a "Completed On Date Range" before exporting'));
    } else if (showDateRange && (moment(queryParams.completedOnEnd).diff(moment(queryParams.completedOnStart), 'days') > 31)) {
      dispatch(alertActions.warning('Narrow your results by selecting a "Completed On Date Range" of no more than 31 days before exporting'));
    } else if (showDateRange && (!queryParams.completedOnStart || !queryParams.completedOnEnd) && !queryParams.questionnaire) {
      dispatch(alertActions.warning('Narrow your results by at least "Appointment Date" and "Questionnaire" before exporting'));
    } else if (!showDateRange && !queryParams.completedOn && !queryParams.questionnaire) {
      dispatch(alertActions.warning('Narrow your results by at least "Completed On" and Questionnaire before exporting'));
    } else if (!queryParams.questionnaire) {
      dispatch(alertActions.warning('Narrow your results by Questionnaire before exporting'));
    } else if (!showDateRange && !queryParams.completedOn) {
      dispatch(alertActions.warning('Narrow your results by "Completed On" before exporting'));
    } else if (!showDateRange && (moment(queryParams.completedOn, 'MM/DD/YYYY').isValid() === false)) {
      dispatch(alertActions.warning('Completed On date is invalid.'));
    } else {
      setShow(true);
    }
  }

  return <>
    <Modal size="lg" show={show} onHide={() => setShow(false)}>
      <Modal.Header>
        <Modal.Title>Export Intakes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup horizontal className="text-center">
          <ListGroup.Item
            action
            as="button"
            disabled={loading}
            onClick={() => {
              setExportType('minimal');
              handleExport('minimal');
            }}
            className="btn btn-outline-primary pt-4 m-3"
          >
            {loading && exportType === "minimal" &&
              <i className="fa fa-spinner fa-spin fa-fw"
                style={{ fontSize: "5em", position: "absolute", top: "1.8em", left: "1.5em" }}></i>}
            <>
              <Row>
                <Col>
                  <h5>Intake Details</h5>
                </Col>
              </Row>
              <Row>
                <Col>
                  <i className="fa fa-thermometer-empty" style={{ fontSize: "4em" }}></i><br />
                </Col>
              </Row>
              <br />
              <Row>
                <Col lg={{ span: 6, offset: 3 }}>
                  <ul className="text-left list-unstyled lead ">
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>First Name</small></li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Last Name</small></li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Date of Birth</small></li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Sex</small></li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Phone Number</small></li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Location</small></li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Status</small></li>
                  </ul>
                </Col>
              </Row>
            </>
          </ListGroup.Item>
          <ListGroup.Item
            action
            as="button"
            disabled={loading}
            onClick={() => {
              setExportType('full');
              handleExport('full');
            }}
            className="btn btn-outline-primary pt-4 m-3"
            style={{
              borderLeftWidth: 1,
              borderBottomLeftRadius: "inherit",
            }}
          >
            {loading && exportType === "full" &&
              <i className="fa fa-spinner fa-spin fa-fw"
                style={{ fontSize: "5em", position: "absolute", top: "1.8em", left: "1.5em" }}></i>}
            <>
              <Row>
                <Col>
                  <h5>Intake and Questions</h5>
                </Col>
              </Row>
              <Row>
                <Col>
                  <i className="fa fa-thermometer-full" style={{ fontSize: "4em" }}></i>
                </Col>
              </Row>
              <br />
              <Row>
                <Col lg={{ span: 8, offset: 2 }} className="pl-4">
                  <ul className="text-left list-unstyled lead">
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Intake Details</small> </li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Question 1</small></li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Question 2</small></li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Question 3</small></li>
                    <li><i className="fa fa-check text-primary"></i>&nbsp;<small>Question ...</small></li>
                    <li>&nbsp;</li>
                    <li>&nbsp;</li>
                  </ul>
                </Col>
              </Row>
            </>
          </ListGroup.Item>
        </ListGroup>
      </Modal.Body>
    </Modal>
    <button type="button" onClick={showSelectExportType} className="btn btn-outline-primary px-5">Export Intakes</button>
  </>
}